import { render, staticRenderFns } from "./ProvisionCreate.vue?vue&type=template&id=28cae00d&scoped=true&"
import script from "./ProvisionCreate.vue?vue&type=script&lang=ts&"
export * from "./ProvisionCreate.vue?vue&type=script&lang=ts&"
import style0 from "./ProvisionCreate.vue?vue&type=style&index=0&id=28cae00d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cae00d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VRow,VSpacer})
